export const environment = {
  production: true,
  appUrl: 'https://theplaypages.com',
  // baseUrl: 'https://api.anythingxxx.quantox.dev/v1',
  baseUrl: 'https://api.anythingxxx.com/v1',
  stripeSecretKey: 'pk_test_qZYbKGeWNGdFBnyLcVIhrX0D00tTKF4wdV',
};
